import { createFileRoute } from "@tanstack/react-router";
import AdminCriteriaPage from "@/pages/admin/criteria";

export const Route = createFileRoute("/app/admin/criteria")({
  component: AdminCriteriaPage,
});
